module.exports = __webpack_public_path__ + "img/su_chance.3a3f06a.png";